module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-header",
    on: {
      "click": function($event) {
        return _vm.toggle()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n    "), (_vm.isActive()) ? _c('span', {
    staticClass: "icon"
  }, [_vm._v("-")]) : _c('span', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggle()
      }
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive()),
      expression: "isActive()"
    }],
    staticClass: "item-body",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75a11a10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/Collapsable.vue
// module id = 978
// module chunks = 0